import styled from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.div`
  background: #F3F5F5;
  border-radius: 6px 6px 0px 0px;
  padding-left: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 47px;

  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.1px;
  color: ${window?.settings?.secondary_color ?? '#04333b'};
`;

export default Wrapper(template);
